// Lib
import React from 'react';
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';
import { useDispatch } from 'react-redux';

// Components
import SheetContainer, { Content, Overlay, Sheet } from '../../mobile/structural/sheet';
import Icon from '../../components/icons/Icon';
import SheetMenu from '../../mobile/structural/sheet/menu/SheetMenu';
import FileUploadForm from '../../components/tools/files/FileUploadForm';

// Util
import { getListChildNewLocation } from '../../../common/elements/utils/elementLocationUtils';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { createAndEditElement } from '../../element/actions/elementActions';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../../common/elements/elementConstants';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { SheetId } from '../../mobile/structural/sheet/sheetTypes';
import { ElementType } from '../../../common/elements/elementTypes';
import { createTaskList } from '../../element/taskList/taskListActions';

const getElementLocation = ({ currentBoardId }: { currentBoardId: string }) =>
    getListChildNewLocation({ listId: currentBoardId });

type Props = {
    currentBoard: ImMNElement;
};

const MobileQuickAddSheet = ({ currentBoard }: Props) => {
    const sheetProps = useSheet(SheetId.QuickAddMenu);

    const currentBoardId = getElementId(currentBoard);

    const dispatch = useDispatch();
    const createNewCard = () =>
        dispatch(
            createAndEditElement({
                elementType: ElementType.CARD_TYPE,
                location: getElementLocation({ currentBoardId }),
            }),
        );

    const createNewTaskList = () =>
        dispatch(
            createTaskList({
                currentBoardId,
                location: getElementLocation({ currentBoardId }),
            }),
        );

    return (
        <SheetContainer className="MobileQuickAddSheet" defaultSnapPoint={'0.5max'} {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <FileUploadForm
                        currentBoardId={currentBoardId}
                        getElementLocation={getElementLocation}
                        creationSource={ELEMENT_CREATION_SOURCES.MOBILE_UPLOAD}
                        uploadCallbackFn={() => sheetProps.dispatchCloseSheet()}
                    >
                        {(openFileInput: () => void) => (
                            <SheetMenu
                                menuItems={[
                                    {
                                        label: 'Note',
                                        onClick: createNewCard,
                                        icon: <Icon name="context-menu-card" />,
                                        dismissSheetOnSelect: true,
                                    },
                                    {
                                        label: 'Todo',
                                        onClick: createNewTaskList,
                                        icon: <Icon name="context-menu-task-list" />,
                                        dismissSheetOnSelect: true,
                                    },
                                    {
                                        label: 'Image',
                                        onClick: openFileInput,
                                        icon: <Icon name="context-menu-camera" />,
                                    },
                                ]}
                            />
                        )}
                    </FileUploadForm>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileQuickAddSheet;
